import { SagaIterator } from 'redux-saga';
import { REPORT_RESET } from 'src/modules/report/actions/ReportActions';
import { RouteMatch } from 'src/modules/routing/types/RouteMatch';
import { Transition } from 'src/modules/routing/types/Transition';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* resetReportData(transition: Transition): SagaIterator<void> {
  if (isOnSameView(transition.to.match)) {
    return;
  }

  try {
    yield* call(logDebug, 'Resetting report data...');
    yield* put(REPORT_RESET.trigger());
    yield* call(logDebug, 'Resetting report data... done');
  } catch (error) {
    yield* call(logError, 'Resetting report data... error', error);
    throw error;
  }
}

function isOnSameView(match: RouteMatch): boolean {
  if (match.state.name === 'bp:project:report') {
    return true;
  }

  return match.parent
    ? isOnSameView(match.parent)
    : false;
}
